// Linking does not prove date coverage: preserve standalone access in generic
// storefronts. Curated themes can explicitly choose their top-level product slots.
export function topLevelMealPlans(plans) {
  return plans.filter(p => !p.is_meal_addon && !p.is_delivery_addon);
}
